import React from 'react';

const Icon = ({ size = '81', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 81 81" fill="none" {...other}>
            <mask id="a" fill="white">
                <path d="M58.582 52.65c6.75 0 12.222-5.471 12.222-12.222 0-6.75-5.472-12.222-12.222-12.222" />
            </mask>
            <path
                d="M58.582 52.65v4c8.959 0 16.222-7.262 16.222-16.222h-8a8.222 8.222 0 0 1-8.222 8.223v4Zm12.222-12.222h4c0-8.959-7.263-16.222-16.222-16.222v8a8.222 8.222 0 0 1 8.222 8.222h4Z"
                fill="#FFCF47"
                mask="url(#a)"
            />

            <path d="M58.582 52.65c6.75 0 12.222-5.471 12.222-12.222 0-6.75-5.472-12.222-12.222-12.222" stroke="#FFCF47" strokeLinejoin="round" />

            <mask id="b" fill="white">
                <path d="M21.915 28.206c-6.75 0-12.222 5.472-12.222 12.222 0 6.75 5.472 12.223 12.222 12.223" />
            </mask>
            <path
                d="M21.915 28.206v-4c-8.96 0-16.222 7.263-16.222 16.222h8a8.222 8.222 0 0 1 8.222-8.222v-4ZM9.693 40.428h-4c0 8.96 7.263 16.223 16.222 16.223v-8a8.222 8.222 0 0 1-8.222-8.223h-4Z"
                fill="#FFCF47"
                mask="url(#b)"
            />

            <path d="M21.915 28.206c-6.75 0-12.222 5.472-12.222 12.222 0 6.75 5.472 12.223 12.222 12.223" stroke="#FFCF47" strokeLinejoin="round" />

            <path
                d="M21.915 52.65V28.207c0-10.125 8.208-18.333 18.333-18.333 10.126 0 18.334 8.208 18.334 18.333v24.445c0 10.125-8.209 18.333-18.334 18.333"
                stroke="#FFCF47"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export default React.memo(Icon);
